import Waves from '../../node_modules/node-waves/dist/waves';

Waves.init();

let vueWaves = {};

vueWaves.install = function (Vue, options = {name: 'waves'}) {
  Vue.directive(options.name, {
    inserted: function (el, binding) {
      Waves.attach(el);
    },
    unbind: function (el) {
      Waves.calm(el);
    }
  });
};

export default vueWaves;



// WEBPACK FOOTER //
// ./src/plugins/vue-waves.js